export default __webpack_public_path__ + "static/media/latina_logo1.df349313.png";